module.exports = __webpack_public_path__ + "static/media/juma-artema.00ff1ad2.jpg";